module.exports = __webpack_public_path__ + "media/images/brand/img-mantle-b0783d5c4bb23ef9e8ae8ea1642cba8c.svg";